export default __webpack_public_path__ + "static/media/hamburger_icon_white.58e45b3e.png";